module.exports = __webpack_public_path__ + "static/media/ALEPAY.7da071b7.svg";